import { MinimalistStepNavbar } from './MinimalistStepNavbar'
import { composeClasses } from '../../../utils/src/strings'

interface MinimalistStepLayoutProps {
  children: React.ReactNode
  backRoute?: string
  tooltipContent?: string
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left'
  classNameContainerChildren?: string
  title?: string
  currentStep?: number
  maxStep?: number
  showBar?: boolean
}

export const MinimalistStepLayout = ({
  children,
  backRoute,
  tooltipContent,
  classNameContainerChildren,
  title,
  currentStep,
  maxStep,
  tooltipPlacement,
  showBar = true
}: MinimalistStepLayoutProps) => {
  return (
    <div className="flex flex-col">
      <main className="grid grid-cols-[1fr] grid-rows-[69px_1fr] h-screen justify-start transition-all duration-300 ease-in-out">
        <MinimalistStepNavbar
          showBar={showBar}
          backRoute={backRoute}
          tooltipContent={tooltipContent}
          title={title}
          currentStep={currentStep}
          maxStep={maxStep}
          tooltipPlacement={tooltipPlacement}
        />
        <div
          className={composeClasses(
            'w-full flex col-span-full row-start-2 row-span-2 ui-kit-scrollbar overflow-y-auto h-[calc(100vh-69px)] overflow-x-hidden',
            classNameContainerChildren
          )}
        >
          {children}
        </div>
      </main>
    </div>
  )
}

export default MinimalistStepLayout
